const tablesettings = [
    {
        key: "mail_address",
        name: "メールアドレス",
        editable: false
    },
    {
        key: "company_name",
        name: "法人名",
        editable: false
    },
    {
        key: "master_number",
        name: "達人番号",
        editable: false
    },
    {
        key: "closing_date",
        name: "決算日",
        editable: false
    },
    {
        key: "estimation",
        name: "申告・試算区分",
        editable: false
    },
    {
        key: "quarterly_estimatopm",
        name: "修正申告又は四半期試算の区分",
        editable: false
    },
    {
        key: "processing_mode",
        name: "処理モード",
        editable: false
    },
    {
        key: "tax_import_mode",
        name: "消費税インポートモード",
        editable: false
    }
];

export { tablesettings };
